import * as React from 'react';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import img_base from '../img/image.png';
import Stack from '@mui/material/Stack';

export default function ProductCard({ title, text, img, setProductId, id, locale }) {
    let learnMore = locale == 'ru' ? 'Подробнее...' : 'Learn more...';
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    const [imgSrc, setImgSrc] = React.useState(img ? API_URL + img : img_base);
    const setid = (id) => {

    }

    return (
        <Link to={`/products/${id}`}> 
        <Card sx={{ width: 235, height: 400, m: 1, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ width: 235, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                <img
                    style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                    alt="news"
                    src={imgSrc}
                    onError={() => setImgSrc(img_base)}
                />
            </Box>
            <Stack sx={{ p: 2, flex: 1, justifyContent: 'space-between' }}>
                <Box sx={{ maxHeight: 190, overflow: 'auto', width: '100%' }}>
                    <Typography gutterBottom variant="h6" component="div" sx={{ fontSize: '20px', lineHeight: '22px'}}>
                        {title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: '12px', lineHeight: '20px'}}>
                        {text}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <div>
                        <Button
                            className='cardButton'
                            size="small"
                            variant=''
                            
                        >
                            {learnMore}
                        </Button>
                    </div>
                </Box>
            </Stack>
        </Card>
        </Link>
        // <Card sx={{ maxWidth: 320, height: 510, m: 3 }}>
        //     <img
        //         style={{ objectFit: 'contain' }}
        //         alt="news"
        //         height="140px"
        //         width="100%"
        //         src={imgSrc}
        //         onError={() => setImgSrc(img_base)}
        //     />

        //     <Stack sx={{ p: 3, height: '320px', justifyContent: 'space-between' }}>
        //         <Box sx={{ height: '240px', overflow: 'auto' }}>
        //             <Typography gutterBottom variant="h6" component="div" sx={{ fontSize: '20px', lineHeight: '24px'}}>
        //                 {title}
        //             </Typography>
        //             <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: '16px'}}>
        //                 {text}
        //             </Typography>
        //         </Box>

        //         <Link to={`/products/${id}`}>
        //             <Button
        //                 className='cardButton'
        //                 size="small"
        //                 variant=''
        //             >
        //                 {learnMore}
        //             </Button>
        //         </Link>
        //     </Stack>
        // </Card>
    );
}